import { useEffect, useState } from 'react';
import {
  HiringHistoryBiddingResponse,
  listHiringHistoryBiddings,
  peekHiringHistoryBiddings,
} from 'services/actions/ai_management_hiring_history';

export interface HiringHistoryBidding {
  biddingId: number;
  notice: string | null;
  date: string | null;
  participants: number;
  value: number | null;
  quantity: number | null;
  winner: string | null;
  description: string | null;
  awarded: boolean;
}

const toBidding = (item: HiringHistoryBiddingResponse): HiringHistoryBidding => ({
  biddingId: item.bidding_id,
  notice: item.edital,
  date: item.data,
  participants: item.participantes,
  value: item.valor,
  quantity: item.quantidade,
  winner: item.vencedor,
  description: item.descricao,
  awarded: item.adjudicado,
});

export function useHiringHistoryBiddings(biddingId: number | null, item: string | null) {
  const peek = () => (biddingId && item ? peekHiringHistoryBiddings(biddingId, item) : undefined);
  const [biddings, setBiddings] = useState<HiringHistoryBidding[]>(
    () => peek()?.data.items.map(toBidding) ?? [],
  );
  const [loading, setLoading] = useState(() => !!biddingId && !!item && !peek());
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!biddingId || !item) return undefined;

    const hit = peek();
    if (hit) {
      setBiddings(hit.data.items.map(toBidding));
      setLoading(false);
      setError(false);
      return undefined;
    }

    let active = true;
    setLoading(true);
    setError(false);

    listHiringHistoryBiddings(biddingId, item)
      .then(({ data }) => {
        if (!active) return;
        setBiddings(data.items.map(toBidding));
        setLoading(false);
      })
      .catch(() => {
        if (!active) return;
        setError(true);
        setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [biddingId, item]);

  return { biddings, loading, error };
}
